export default __webpack_public_path__ + "static/media/banner_desativacao_portal.ab6b11cd.png";